<template>
  <div>
    <!-- <el-row :gutter="20">
      <el-col :span="6" :xs="24">
        <div class="card" @click="offLine">
          <img class="img" src="../../../assets/微信图片_20200402154627.png" />
          <div class="card-content">
            <div>在线设备/设备总数(台)</div>
            <div>
              {{ stat.onLineNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" :xs="24">
        <div class="card" @click="onLine">
          <img class="img" src="../../../assets/微信图片_20200402154621.png" />
          <div class="card-content">
            <div>离线设备/设备总数(台)</div>
            <div>
              {{ stat.offLineNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" :xs="24">
        <div class="card" @click="$router.push({ name: '未绑定设备' })">
          <img class="img" src="../../../assets/9.png" />
          <div class="card-content">
            <div>未绑定设备/设备总数(台)</div>
            <div>
              {{ stat.unBindNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col
        class="groud_card"
        :span="4"
        :xs="24"
        v-for="item in groupDetailList"
        :key="item.title"
      >
        <div class="groud_card_title">
          <div class="groud_card_icon" :style="{ background: item.bgc }">
            <Icon
              class="icon_logo"
              :style="{ color: item.color }"
              :icon="item.icon"
            />
          </div>
          <div class="groud_text">{{ item.title }}</div>
        </div>
        <div class="groud_card_value">
          <!-- 收费方式 -->
          <template v-if="item.key == 'charge'">
            <template v-if="groupDetailObj.chargeType == '1'">
              <div
                class="value_share"
                v-for="item in groupDetailObj.deviceGroupChargeList"
                :key="item.id"
              >
                {{ item.startPower }}瓦--{{ item.endPower }}瓦
                {{ item.money }}元 {{ item.interval }}分钟
              </div>
            </template>
            <template v-if="groupDetailObj.chargeType == '2'">
              <div
                v-if="groupDetailObj.serviceChargeByTime == '1'"
                style="margin-bottom: 4px"
              >
                按时间收服务费：{{ groupDetailObj.serviceChargeTimeMoney }}元 /
                {{ groupDetailObj.serviceChargeTime }}分钟 (不足{{
                  groupDetailObj.serviceChargeTime
                }}分钟，按{{ groupDetailObj.serviceChargeTime }}分钟计算)
              </div>
              <template
                v-if="
                  groupDetailObj.informationOfChargeByPowerList &&
                  groupDetailObj.informationOfChargeByPowerList.length
                "
              >
                <div class="charge_rule_wrapper">
                  <div class="rule_header">
                    <div class="header_item">峰平谷</div>
                    <div class="header_item">时间</div>
                    <div class="header_item">电费¥</div>
                    <template v-if="groupDetailObj.serviceChargeByTime == '0'">
                      <div class="header_item">服务费¥</div>
                      <div class="header_item">总价/度</div>
                    </template>
                  </div>
                  <div class="rule_detai">
                    <div
                      class="detail_item"
                      v-for="(
                        item, index
                      ) in groupDetailObj.informationOfChargeByPowerList"
                      :key="index"
                    >
                      <div class="item_text">
                        {{
                          item.peak == 0 ? "峰" : item.peak == 1 ? "平" : "谷"
                        }}
                      </div>
                      <div class="item_text">
                        {{ item.startTime }}-{{ item.endTime }}时
                      </div>
                      <div class="item_text">
                        {{ item.powerFare.toFixed(4) }}
                      </div>
                      <template
                        v-if="groupDetailObj.serviceChargeByTime == '0'"
                      >
                        <div class="item_text">
                          {{ item.powerServiceFare.toFixed(4) }}
                        </div>
                        <div class="item_text">
                          {{
                            (item.powerFare + item.powerServiceFare).toFixed(4)
                          }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                按度数，{{ groupDetailObj.powerFare }}元 / 度
              </template>
            </template>
          </template>
          <!-- 包月套餐 -->
          <template v-if="item.key == 'power'">
            <div
              class="value_share"
              v-for="item in groupDetailObj.monthlyInfoList"
              :key="item.id"
            >
              {{ item.money }}元 {{ item.freeChargeNum }}小时 - 最大{{
                item.endPower
              }}瓦
            </div>
          </template>
          <!-- 分润方 -->
          <template v-if="item.key == 'share'">
            <div
              class="value_share"
              v-for="item in groupDetailObj.groupDividendConfList"
              :key="item.id"
            >
              {{ item.dividend.name }}, 分润 {{ item.dividendRatio }}%
            </div>
          </template>
          <!-- 具体位置 -->
          <template v-if="item.key == 'address'">
            <div class="value_share">
              {{ groupDetailObj.address }}
            </div>
          </template>
          <!-- 联系电话 -->
          <template v-if="item.key == 'mobile'">
            <div class="value_share">
              {{ groupDetailObj.mobile }}
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="5" class="m-mp-10">
      <el-form ref="params" :model="params">
        <el-col :span="3" :xs="12">
          <el-form-item prop="groupId">
            <el-select
              v-model="params.groupId"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
              placeholder="小区"
              value="groupingValue"
              @change="search"
              clearable
            >
              <el-option
                v-for="(item, index) in GroupList"
                :key="index"
                :label="item.groupName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="online">
            <el-select v-model="params.online" placeholder="状态">
              <el-option
                v-for="item in status"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="id">
            <el-input
              v-model="params.id"
              placeholder="设备编号"
              maxlength="11"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="ids">
            <el-input
              v-model="params.ids"
              placeholder="硬件UID"
              maxlength="15"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="name">
            <el-input
              v-model="params.name"
              placeholder="设备名称"
              maxlength="40"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="deviceQrCodeId">
            <el-input
              v-model="params.deviceQrCodeId"
              placeholder="主机二维码编号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button plain type="success" @click="handleResetBtnClick"
            >重置</el-button
          >
        </el-col>
      </el-form>
    </el-row>
    <el-row :gutter="5" class="xs-mp-10">
      <el-col :span="3" :xs="12">
        <el-button type="primary" @click="addPowerStationDialog = true"
          >新增设备</el-button
        >
      </el-col>
      <!-- <el-col :span="3" :xs="12">
        <el-button type="primary" @click="addGroupDialog=true">新增小区</el-button>
      </el-col> -->
    </el-row>
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
      :default-sort="{ prop: 'id', order: 'descending' }"
    >
      <el-table-column fixed label="设备编号" prop="id" width="100">
        <template #default="scope">
          <span class="click" @click="skipPowerStation(scope.row)">
            {{ scope.row.id }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="设备名称" prop="name">
        <template #default="scope">
          <span class="click" @click="skipPowerStation(scope.row)">
            {{ scope.row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="硬件UID" prop="ids" width="110">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.ids === '-1' ? '更换后可用' : scope.row.ids"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.ids === "-1" ? "更换后可用" : scope.row.ids }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="设备类型"
        prop="versions"
        width="78"
        align="center"
      >
        <template #default="scope">
          {{ versions(scope.row.versions) }}
        </template>
      </el-table-column>
      <el-table-column label="主机二维码编号" align="center" width="120">
        <template #default="scope">
          {{ scope.row.deviceQrCodeId || "未绑定" }}
        </template>
      </el-table-column>
      <el-table-column
        label="绑定时间"
        width="150"
        prop="bindTime"
        align="center"
      >
        <template #default="scope">
          {{ timeFormat(scope.row.bindTime) }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="年费到期时间"
        v-if="agentInfo.chargeModel === 2"
        width="150"
        prop="chargeModel"
        align="center"
      >
        <template #default="scope">
          {{ timeFormat(scope.row.payAnnualFeeTime) }}
          {{
            scope.row.payAnnualFeeTime - parseInt(new Date().getTime() / 1000) >
            0
              ? ""
              : "已过期"
          }}
          <el-button
            size="mini"
            type="danger"
            @click="payAnnualFee(scope.row.id)"
            >续费</el-button
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        label="离线时间"
        width="150"
        prop="lastCommunicationTime"
        align="center"
      >
        <template #default="scope">
          {{
            scope.row.lastCommunicationTime
              ? timeFormat(scope.row.lastCommunicationTime)
              : ""
          }}
        </template>
      </el-table-column> -->
      <el-table-column
        label="状态/信号"
        width="110"
        prop="`signal`"
        align="center"
      >
        <template #default="scope">
          <template v-if="scope.row.signal >= 50"> 有线 </template>
          <template v-else>
            {{ scope.row.signal > 0 ? "在线 " + scope.row.signal : "下线" }}
          </template>
        </template>
      </el-table-column>
      <!-- <el-table-column label="插座数量" prop="socketSize" align="center"/> -->
      <el-table-column
        label="充电人数"
        width="110"
        prop="charageingSocketNum"
        align="center"
      />
      <el-table-column label="小区" align="center">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="
              scope.row.deviceGroup ? scope.row.deviceGroup.groupName : '无'
            "
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{
                scope.row.deviceGroup ? scope.row.deviceGroup.groupName : "无"
              }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <!-- <el-table-column :width="150" label="小区操作" align="center">
        <template #default="scope">
          <template v-if="!!scope.row.deviceGroup">
            <el-button size="mini" type="danger" @click="remove(scope.row.id)"
              >移除
            </el-button>
            <el-button size="mini" type="primary" @click="shift(scope)">
              转移
            </el-button>
          </template>
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="join(scope.row.id)"
            >加入</el-button
          >
        </template>
      </el-table-column> -->
      <!--      <el-table-column label="计费方式">-->
      <!--        <template #default="scope">-->
      <!--          {{ scope.row.chargeType === '1' ? '按时间' : '按度数' }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!-- <el-table-column label="区域" prop="city" align="center">
        <template #default="scope">
          {{ scope.row.city }}
        </template>
      </el-table-column> -->
      <el-table-column :width="400" label="操作" align="center">
        <template #default="scope">
          <!-- <el-button size="mini" @click="skipPowerStation(scope.row)"
            >详细</el-button
          > -->
          <el-button size="mini" type="danger" @click="unbind(scope.row.id)"
            >解绑</el-button
          >
          <el-button size="mini" type="warning" @click="change(scope.row)"
            >更换</el-button
          >
          <el-button size="mini" type="success" @click="transfer(scope.row)"
            >转移</el-button
          >
          <el-button size="mini" @click="free(scope.row)">免费充电</el-button>
          <el-button size="mini" @click="handleRefreshCache(scope.row)"
            >刷新缓存</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <add-group-dialog :dialog="addGroupDialog" />
    <add-power-station-dialog
      :dialog="addPowerStationDialog"
      v-if="addPowerStationDialog"
      :defaultGroupId="params.groupId"
    />
    <remove-group-dialog :device-id="deviceId" :dialog="removeGroupDialog" />
    <!-- <shift-group-dialog
      :device-id="deviceId"
      :dialog="shiftGroupDialog"
      :groups="GroupList"
      :old-group-name="shiftGroupName"
    />
    <join-group-dialog
      :device-id="deviceId"
      :dialog="joinGroupDialog"
      :groups="GroupList"
    /> -->
    <un-bind-dialog :device-id="deviceId" :dialog="unBindDialog" />
    <change-dialog
      :device-versions="deviceVersions"
      :device-id="deviceId"
      :dialog="changeDialog"
    />
    <transfer-dialog
      :device-id="deviceId"
      :transferInitId="transferInitId"
      :dialog="transferDialog"
    />
    <free-dialog
      :device-id="deviceId"
      :freeVersions="freeVersions"
      :dialog="freeDialog"
    />
  </div>
</template>

<script>
import Page from "@/components/Page";
import {
  payDeviceAnnualFee,
  refreshCache,
} from "@/maintain/api/device/ChargingPileController";
import getAgentDeviceByPage from "@/maintain/api/device/charging-pile-manage/getAgentDeviceByPage";
import getGroupList from "@/maintain/api/device/device-group-manage/getGroupList";
import maintainGetGroupDetailById from "@/maintain/api/device/device-group-manage/maintainGetGroupDetailById";
import AddGroupDialog from "@/maintain/components/PowerStationDialog/addGroupDialog";
import AddPowerStationDialog from "@/maintain/components/PowerStationDialog/addPowerStationDialog";
import ChangeDialog from "@/maintain/components/PowerStationDialog/changeDialog";
import FreeDialog from "@/maintain/components/PowerStationDialog/freeDialog";
import RemoveGroupDialog from "@/maintain/components/PowerStationDialog/removeGroupDialog";
import transferDialog from "@/maintain/components/PowerStationDialog/transferDialog";
import UnBindDialog from "@/maintain/components/PowerStationDialog/unBindDialog";

import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import ResMessage from "@/mixin/resDisposeMixin";
import scanMixin from "@/mixin/scanMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import UserInfoStore from "@/utils/UserInfoStore";
import { Message } from "element-ui";
import debounce from "lodash/debounce";

export default {
  name: "MyPowerStationOne",
  components: {
    Page,
    FreeDialog,
    AddPowerStationDialog,
    ChangeDialog,
    UnBindDialog,
    RemoveGroupDialog,
    AddGroupDialog,
    transferDialog,
  },
  mixins: [
    timeMixin,
    pageMixin,
    dialogMixin,
    ResMessage,
    searchMixin,
    scanMixin,
  ],
  props: {
    beg: Number,
  },
  watch: {
    "params.groupId": {
      handler() {
        this.getGroupDetailById(this.params.groupId);
      },
    },
  },
  data() {
    return {
      groupDetailList: [
        {
          title: "收费方式",
          key: "charge",
          icon: "icon-shoufeiguanli",
          color: "#f83f3a",
          bgc: "rgba(248, 63, 58, 0.1)",
        },
        {
          title: "包月套餐",
          key: "power",
          icon: "icon-yuebao",
          color: "#f1a00e",
          bgc: "rgba(244, 182, 70, 0.1)",
        },
        {
          title: "分润方",
          key: "share",
          icon: "icon-zhjf",
          color: "#29c19b",
          bgc: "rgba(41, 193, 155, 0.1)",
        },
        {
          title: "具体位置",
          key: "address",
          icon: "icon-weizhi",
          color: "#4d9aff",
          bgc: "rgba(130, 184, 255,0.1)",
        },
        {
          title: "联系电话",
          key: "mobile",
          icon: "icon-24gf-phoneLoudspeaker",
          color: "#e600ac",
          bgc: "rgba(255, 102, 204, 0.1)",
        },
        // {
        //   title: "最大功率",
        //   key: "power",
        //   icon: "icon-gongshuaiyinsu",
        //   color: "#e600ac",
        //   bgc: "rgba(255, 102, 204, 0.1)",
        // },
      ],
      groupDetailObj: {},
      agentInfo: UserInfoStore.getInfo(),
      size: 10,
      current: 1,
      stat: {
        total: 0,
        onLineNum: 0,
        offLineNum: 0,
        unBindNum: 0,
      },
      loadTable: false,
      records: [],
      GroupList: [],
      deviceId: undefined,
      deviceVersions: undefined,
      freeVersions: undefined,
      shiftGroupName: undefined,
      joinGroupDialog: false,
      freeDialog: false,
      addPowerStationDialog: false,
      addGroupDialog: false,
      unBindDialog: false,
      changeDialog: false,
      removeGroupDialog: false,
      shiftGroupDialog: false,
      params: {
        status: 1,
        name: undefined,
        id: undefined,
        ids: undefined,
        deviceQrCodeId: undefined,
        online: undefined,
        groupId: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      status: [
        { value: "0", label: "离线" },
        { value: "1", label: "在线" },
        { value: "2", label: "全部" },
      ],
      transferInitId: undefined,
      transferDialog: false,
    };
  },
  mounted() {
    // agentGetDeviceNumDateil().then((res) => {
    //   this.stat = res.data;
    // });
    const fromDetailParams = sessionStorage.getItem("fromDetailParams");
    if (fromDetailParams == "true") {
      Object.keys(this.$store.state.app.powerStationParams).forEach((key) => {
        this.$set(
          this.params,
          key,
          this.$store.state.app.powerStationParams[key]
        );
      });
      // this.params = this.$store.state.app.powerStationParams;
      sessionStorage.removeItem("fromDetailParams");
    }
    getGroupList().then((res) => {
      this.GroupList = res.data;
      if (!this.params.groupId) {
        if (this.$route.query.groupId) {
          this.params.groupId = +this.$route.query.groupId;
        } else if (this.GroupList.length == 1) {
          this.params.groupId = this.GroupList[0].id;
        }
        // else if (this.GroupList.length) {
        //   this.params.groupId = this.GroupList[0].id;
        // }
      }

      if (this.$route.query.status) {
        this.params.online = this.$route.query.status;
      }
      // this.getGroupDetailById(this.params.groupId)
      // if (this.params.groupId) this.search();
      this.search();
    });
  },
  methods: {
    handleResetBtnClick() {
      this.reset(
        this.$route.query.groupId ? { notResetFields: ["groupId"] } : {}
      );
    },
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleRefreshCache: debounce(function (row) {
      if (row) {
        refreshCache(row.ids).then(() => {
          Message({
            message: "刷新缓存成功",
            type: "success",
            duration: 1500,
          });
        });
      }
    }, 500),
    getAgentGroupDetailById(id) {
      return maintainGetGroupDetailById({ id });
    },
    getGroupDetailById(id) {
      if (!id) return (this.groupDetailObj = {});

      this.getAgentGroupDetailById(id).then((res) => {
        console.log(res);
        this.groupDetailObj = res.data;
      });
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      this.fetchData();
    },
    offLine() {
      this.params.online = "1";
      this.current = 1;
      this.fetchData();
    },
    onLine() {
      this.params.online = "0";
      this.current = 1;
      this.fetchData();
    },
    fetchData() {
      // if (!this.params.groupId) return;

      this.loadTable = true;
      if (this.params.sortName == undefined) this.params.sortName = "id";
      if (this.params.sortType == undefined) this.params.sortType = "DESC";
      getAgentDeviceByPage(this.params, this.current, this.size)
        .then((res) => {
          this.records = res.data.records;
          // const unique = new Set(this.records.map((r) => r.deviceGroup.id));
          // 如果设备都在同一小区，则自动选中该小区，显示详细信息
          // if (unique.size == 1) {
          //   this.$set(this.params, "groupId", this.records[0].deviceGroup.id);
          // }

          // 如果设备编号和硬件UID有值，且设备都在同一小区，则自动选中该小区，显示详细信息
          if (this.params.id || this.params.ids) {
            const unique = new Set(this.records.map((r) => r.deviceGroup.id));
            if (unique.size == 1) {
              this.$set(this.params, "groupId", this.records[0].deviceGroup.id);
            }
          }

          this.total = res.data.total;
          console.log(this.size, this.current, this.total);
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    free(row) {
      if (row.signal <= 0) {
        Message({
          message: "当前设备已离线",
          type: "error",
          duration: 3 * 1000,
        });
      } else {
        this.deviceId = row.id;
        this.freeVersions = row.versions;
        this.freeDialog = true;
      }
    },
    // handleRefreshCache: debounce(function (row) {
    //   if (row) {
    //     refreshCache(row.ids).then(() => {
    //       Message({
    //         message: "刷新缓存成功",
    //         type: "success",
    //         duration: 1500,
    //       });
    //     });
    //   }
    // }, 500),
    join(id) {
      this.deviceId = id;
      this.joinGroupDialog = true;
    },
    shift(scope) {
      this.deviceId = scope.row.id;
      this.shiftGroupName = scope.row.deviceGroup.groupName;
      this.shiftGroupDialog = true;
    },
    change(row) {
      this.deviceId = row.id;
      this.deviceVersions = row.versions;
      this.changeDialog = true;
    },
    transfer(row) {
      console.log(row);
      this.deviceId = row.id;
      this.transferInitId = row.deviceGroup.id;
      this.transferDialog = true;
    },
    remove(id) {
      this.deviceId = id;
      this.removeGroupDialog = true;
    },
    unbind(id) {
      this.unBindDialog = true;
      this.deviceId = id;
    },
    payAnnualFee(id) {
      payDeviceAnnualFee(
        { id: id, agentCode: "06595eebe6c140c4b63828d7d1ab8ead" },
        {}
      ).then((res) => {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            // eslint-disable-line
            appId: res.data.appId, //公众号ID，由商户传入
            timeStamp: res.data.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: res.data.nonceStr, //随机串
            package: res.data.package,
            signType: res.data.signType, //微信签名方式：
            paySign: res.data.paySign, //微信签名
          },
          function (res) {
            console.log(res);
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              this.search();
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
          }
        );
      });
      console.log(id);
    },
    skipPowerStation(row, activeTab) {
      // console.log(this.params)
      if (this.$route.query && Object.keys(this.$route.query).length) {
        this.$router.push({ path: this.$route.path, query: {} });
      }
      console.log(this.params);
      console.log(row);
      if (row.ids == "-1") {
        return this.$message.error("更换后可用");
      }
      this.$store.commit("app/setPowerStationParams", this.params);
      this.$router.push({
        // name: "设备详细",
        path: `/PowerStationDetail/${row.id}`,
        // params: {
        //   id: row.id,
        // },
        query: {
          ids: row.ids,
          versions: row.versions,
          activeTab: activeTab,
        },
      });
    },
  },
  // mounted() {
  // const isDetail = sessionStorage.getItem("isDetail");
  // if (isDetail == "true") {
  //   this.fetchData();
  // }
  // },
  computed: {
    versions() {
      return (versions) => {
        switch (versions) {
          case "1":
            return "8插座";
          case "2":
            return "16插座";
          case "3":
            return "双路ab款";
          case "4":
            return "10路";
          case "5":
            return "4路";
          case "6":
            return "3路";
          case "7":
            return "双路";
          case "8":
            return "新版双路";
          case "9":
            return "新版10路";
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/my";

@include mobile {
  .card {
    height: 65px !important;
  }

  .groud_card {
    .groud_card_value {
      height: 90px !important;
    }
  }
}

.charge_rule_wrapper {
  .rule_header {
    display: flex;
    align-items: center;
    .header_item {
      width: 20%;
      text-align: center;
      font-weight: bold;
      color: #5f5f5f;
    }
  }
  .rule_detai {
    margin-top: 6px;
    .detail_item {
      margin-bottom: 2px;
      display: flex;
      align-items: center;
      .item_text {
        width: 20%;
        text-align: center;
      }
    }
  }
}

.groud_card {
  box-sizing: border-box;
  // cursor: pointer;
  border: 1px solid #f0f0f0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 3px 5px;
  // display: flex;
  // align-items: center;
  // padding-left: 30px;
  margin-right: 16.5px;
  margin-bottom: 8px;
  border-radius: 5px;

  .groud_card_title {
    display: flex;
    align-items: center;
    // justify-content: center;
    // margin-bottom: 4px;
    font-size: 14px;
    // border-bottom: 1px solid #f4f4f4;
    padding-bottom: 5px;
    padding: 5px;
    box-shadow: 0 1px 3px #e3e3e3;

    .groud_card_icon {
      margin-right: 8px;
      // padding: 2px 3px;
      border-radius: 4px;

      .icon_logo {
        font-size: 22px;
      }
    }

    .groud_text {
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .groud_card_value {
    padding: 4px 8px;
    height: 100px;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    font-size: 14px;

    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .value_share {
      border-bottom: 1px dashed #e4e4e4;
      margin-bottom: 3px;
      padding-bottom: 2px;
    }
  }
}

.card {
  cursor: pointer;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  height: 120px;
  padding-left: 30px;

  .img {
    width: 58px;
    height: 58px;
    display: block;
  }

  .card-content {
    margin-left: 10px;

    div:last-child {
      margin-top: 5px;
    }
  }
}
</style>
